import {
  PickerBaseTriggerHTMLProps,
  PickerBaseTriggerOptions,
  usePickerBaseTrigger,
} from "../picker-base";
import { createComponent, createHook } from "../system";

import { DATE_PICKER_TRIGGER_KEYS } from "./__keys";

export type DatePickerTriggerOptions = PickerBaseTriggerOptions;

export type DatePickerTriggerHTMLProps = PickerBaseTriggerHTMLProps;

export type DatePickerTriggerProps = DatePickerTriggerOptions &
  DatePickerTriggerHTMLProps;

export const useDatePickerTrigger = createHook<
  DatePickerTriggerOptions,
  DatePickerTriggerHTMLProps
>({
  name: "DatePickerTrigger",
  compose: usePickerBaseTrigger,
  keys: DATE_PICKER_TRIGGER_KEYS,
});

export const DatePickerTrigger = createComponent({
  as: "button",
  memo: true,
  useHook: useDatePickerTrigger,
});
